import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

declare global {
    interface Window { lat_cockpit_home_id: number; }
}

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: ()=>{
            return { path: 'cockpit/' + (window.lat_cockpit_home_id ? window.lat_cockpit_home_id : 1) }
        }
    },
    {
        path: '/cockpits',
        name: 'cockpits',
        component: Home
    },
    {
        path: '/login',
        'name': 'login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/backend',
        'name': 'backend',
        component: () => import('../views/Backend.vue')
    },
    {
        path: '/frontend',
        'name': 'frontend',
        component: () => import('../views/Frontend.vue')
    },
    {
        path: '/cockpit/:aircraft',
        'name': 'cockpit',
        component: () => import(/* webpackChunkName: "cockpit" */'../views/CockpitLoader.vue')
    },
];

const router = new VueRouter({
    routes
});

// router.beforeEach(async (to, from, next) => {
//
//     // setTimeout(() => {
//     //     if (!store.state.user && to.name !== 'login') next('/login')
//     //     else next()
//     // }, 500)
//
// })

export default router
